import { render, staticRenderFns } from "./invasion-notifications.vue?vue&type=template&id=64b1e4b2&lang=pug&"
import script from "./invasion-notifications.vue?vue&type=script&lang=js&"
export * from "./invasion-notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports